
import React from "react";
import { Facebook, Instagram } from "lucide-react";

interface SocialMediaLinksProps {
  facebook?: string;
  instagram?: string;
  tiktok?: string;
}

const SocialMediaLinks: React.FC<SocialMediaLinksProps> = ({ 
  facebook, 
  instagram, 
  tiktok 
}) => {
  if (!facebook && !instagram && !tiktok) {
    return null;
  }

  return (
    <div className="mt-4">
      <h4 className="text-sm font-medium mb-2 text-muted-foreground">Social Media</h4>
      <div className="flex space-x-3">
        {facebook && (
          <a 
            href={facebook} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-eco-500 hover:text-eco-600"
            aria-label="Facebook"
          >
            <Facebook className="h-5 w-5" />
          </a>
        )}
        {instagram && (
          <a 
            href={instagram} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-eco-500 hover:text-eco-600"
            aria-label="Instagram"
          >
            <Instagram className="h-5 w-5" />
          </a>
        )}
        {tiktok && (
          <a 
            href={tiktok} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-eco-500 hover:text-eco-600"
            aria-label="TikTok"
          >
            {/* Custom TikTok icon since it's not available in lucide-react */}
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              className="h-5 w-5"
            >
              <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"></path>
            </svg>
          </a>
        )}
      </div>
    </div>
  );
};

export default SocialMediaLinks;
